import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=f2467c66&scoped=true"
import script from "./Copyright.vue?vue&type=script&lang=js"
export * from "./Copyright.vue?vue&type=script&lang=js"
import style0 from "./Copyright.vue?vue&type=style&index=0&id=f2467c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2467c66",
  null
  
)

export default component.exports